import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { useEffect, useState } from 'react';
import { IntlProvider } from '@alltrails/shared/react-intl';
import Terms from './Terms';

export default function CookiePolicyCSR() {
  const [messages, setMessages] = useState();
  const languageRegionCode = useLanguageRegionCode();

  useEffect(() => {
    async function loadMessages() {
      setMessages(await import(`./compiled-lang/${languageRegionCode}.json`));
    }

    loadMessages();
  }, [languageRegionCode]);

  if (!messages) {
    const fallback = document.querySelector(`[data-react-class="Terms"]`);
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: fallback.innerHTML }} />;
  }

  return (
    <IntlProvider defaultLocale={LanguageRegionCode.English} locale={languageRegionCode} messages={messages}>
      <Terms />
    </IntlProvider>
  );
}
